import { MouseEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useQuery from "../../hooks/useQuery";

import { selectCurrentBrand } from "../../redux/shop/shop.selectors";

import useStyles from "./sort.styles";

const SortMethod = (props: any) => {
  const { element, selectedSortMethod, handleClick } = props;

  const [selected, setSelected] = useState(
    element.value === selectedSortMethod,
  );

  const classes = useStyles({ selected });

  useEffect(() => {
    setSelected(element.value === selectedSortMethod);
  }, [selectedSortMethod]);

  return (
    <button value={element.value} className={classes.btn} onClick={handleClick}>
      {element.label}
    </button>
  );
};

const Sort = (props: any) => {
  const dispatch = useDispatch();
  const query = useQuery();

  const {
    open,
    setOpen,
    sortElements,
    selectedSortMethod,
    setSelectedSortMethod,
    filterTerms,
    extraFilterTerms,
    fetchCollectionItems,
    fetchBrandItems,
  } = props;

  const classes = useStyles({ open });

  const [currentCollectionId] = useState(
    query.has("collectionId") ? query.get("collectionId") : "",
  );

  const currentBrand = useSelector(selectCurrentBrand);

  const [currentBrandName, setCurrentBrandName] = useState(
    currentBrand ? currentBrand.brandName : "",
  );

  useEffect(() => {
    setCurrentBrandName(currentBrand ? currentBrand.brandName : "");
  }, [currentBrand]);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const value = e.currentTarget.value;
    if (selectedSortMethod === value) {
      setSelectedSortMethod("");
    } else {
      setSelectedSortMethod(value);
    }
  };

  useEffect(() => {
    const tempFilterTerms = Object.assign({}, filterTerms);
    const tempExtraFilterTerms = Object.assign({}, extraFilterTerms);

    Object.keys(tempFilterTerms).forEach((filterKey) => {
      if (
        tempFilterTerms[filterKey] &&
        tempFilterTerms[filterKey].selectedOptions.length === 0
      ) {
        delete tempFilterTerms[filterKey];
      }
    });

    Object.keys(tempExtraFilterTerms).forEach((filterKey) => {
      if (
        tempExtraFilterTerms[filterKey] &&
        tempExtraFilterTerms[filterKey].selectedOptions.length === 0
      ) {
        delete tempExtraFilterTerms[filterKey];
      }
    });

    if (query.has("collectionId")) {
      fetchCollectionItems(dispatch, {
        currentCollectionId,
        filterTerms: tempFilterTerms,
        extraFilterTerms: tempExtraFilterTerms,
        sortBy: selectedSortMethod ? selectedSortMethod : null,
      });
    } else if (query.has("brandId")) {
      fetchBrandItems(dispatch, {
        searchKeyword: currentBrand?.brandName,
        filterTerms: tempFilterTerms,
        extraFilterTerms: tempExtraFilterTerms,
        sortBy: selectedSortMethod ? selectedSortMethod : null,
      });
    }

    setOpen(false);
  }, [selectedSortMethod]);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <div className={classes.outerContainer}>
      <div className={classes.innerContainer}>
        {sortElements.map((el: any) => (
          <SortMethod
            key={el.value}
            element={el}
            selectedSortMethod={selectedSortMethod}
            handleClick={handleClick}
          />
        ))}
      </div>
    </div>
  );
};

export default Sort;
